<template>
    <div class="logs-search-wrapper">
        <search-group title="日志查询" @search="find" @clear="clearValue" :span="19">
            <Row  class="mb16" :gutter="16">
                <Col span="6">
                     <Select v-model="params.projectFid" @on-change="changeProject" placeholder="项目名称">
                        <Option value="">请选择</Option>
                        <Option v-for="(item,index) in list.projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
                    </Select>
                </Col>
                <Col span="4">
                     <Select v-model="params.buildingFid" placeholder="楼栋">
                        <Option value="">请选择</Option>
                        <Option v-for="item in list.buildList" :value="item.value" :key="item.value">{{item.text}}</Option>
                    </Select>
                </Col>
                <Col span="4">
                    <Input v-model="params.deviceName" placeholder="按设备名称搜索" @keyup.enter.native="find"></Input>
                </Col>
                 <Col span="4">
                    <Input v-model="params.userName" placeholder="按租客姓名搜索" @keyup.enter.native="find"></Input>
                </Col>
                 <Col span="4">
                    <Input v-model="params.userPhone" placeholder="按租客联系方式搜索" @keyup.enter.native="find"></Input>
                </Col>
            </Row>
            <Row class="mb16" :gutter="16">
                <Col span="8">
                    <DatePicker type="datetimerange" placeholder="开门/电梯时间" format="yyyy-MM-dd" style="width:100%" @on-change="getDate"></DatePicker>
                </Col>
                <Col span="4">
                    <Select v-model="params.deviceType" placeholder="设备类型">
                        <Option value="">请选择</Option>
                        <Option value="0">门禁</Option>
                        <Option value="1">梯控</Option>
                    </Select>
                </Col>
                <Col span="6">
                    <Select v-model="params.noticeName" placeholder="开门方式">
                        <Option value="">请选择</Option>
                        <Option value="ownerQrcodeOpen">租客二维码开门</Option>
                        <Option value="visitorQrcodeOpen">访客二维码开门</Option>
                        <Option value="nfcOpen">员工IC卡开门</Option>
                        <Option value="nfcAuth">未授权IC卡开门</Option>
                        <Option value="ownerRemoteOpen">租客远程开门</Option>
                        <Option value="empRemoteOpen">员工远程开门</Option>
                    </Select>
                </Col>
            </Row>
        </search-group>
    </div>
</template>

<script type="text/ecmascript-6">
// import SearchGroup from 'components/SearchGroup/index';
import { getBuildInfo } from 'api/ladder.js';
export default {
    components: {
        // SearchGroup
    },
    data () {
        return {
            params:{
                projectFid:'',
                buildingFid:'',
                deviceName:'',
                userName:'',
                userPhone:'',
                deviceType:'',
                openTimeStart:'',
                openTimeEnd:'',
                noticeName:'',
                limit:10,
                page:1
            },
            list:{
                projectList:[],
                buildList:[]
            }
        }
    },
    created () {
      this.init();
    },
    methods: {
        find() {
            this.$emit('find',this.params)
        },
        clearValue() {
            this.params.projectFid = '';
            this.params.buildingFid = '';
            this.params.deviceName = '';
            this.params.userName = '';
            this.params.userPhone = '';
            this.params.noticeName = '';
            this.params.openTimeStart = '';
            this.params.openTimeEnd = '';
        },
        init() {
            getBuildInfo().then(res => {
                this.list.projectList = res.data;
            })
        },
        changeProject(value) {
            this.params.buildingFid = '';
            if(value){
                let data = this.list.projectList.filter(item => item.value === value);
                this.list.buildList = data[0]['children'];
            }else{
                this.list.buildList = [];
            }
        },
        getDate(date) {
            this.params.openTimeStart = date[0];
            this.params.openTimeEnd = date[1];
        }
    }
}
</script>

<style lang="css" scoped>

</style>
